















import {Component, Prop, Vue} from "vue-property-decorator";

@Component({})
export default class NotFound extends Vue {
    protected onHomepageBtnClicked(evt: MouseEvent) {
        window.location.pathname = "/";
    }
}
